
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqoWIPwzPlSVNYyxUObiGnqLVeAThn1spePQxk5lbNgqAMeta } from "/codebuild/output/src2471201338/src/src/pages/faq.vue?macro=true";
import { default as menuB8AirgDu1slVU1nP_Lf15aAsNpHyJ9V_45BJYcC3OgjecMeta } from "/codebuild/output/src2471201338/src/src/pages/menu.vue?macro=true";
import { default as indextb_45RV_45b33YfrNCGeVJzr_ioFH3NGlVggVbeP2bMJsvoMeta } from "/codebuild/output/src2471201338/src/src/pages/index.vue?macro=true";
import { default as contactCRLaEI93vrxNdhgwj_45jK6X9fXXsJ1cZAUtbNyflqrqoMeta } from "/codebuild/output/src2471201338/src/src/pages/contact.vue?macro=true";
import { default as tutorialUfcLnWTO5FHhLrFbIU9wX0SYmLWSIHSMiFCcv6XBw9YMeta } from "/codebuild/output/src2471201338/src/src/pages/tutorial.vue?macro=true";
import { default as agreementti3oi6El7V68Z6NMoibk_45Y8A8pc6qpahz0u58T_EI5UMeta } from "/codebuild/output/src2471201338/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass6Tu17zY6YYuXHvN4X4IuF3L1dPx3iWdkC0mVvMGOWzUMeta } from "/codebuild/output/src2471201338/src/src/pages/about-pass.vue?macro=true";
import { default as index3WLjNwfm5ZzY2mZUv1dEOcJd_i8EhaOP3SzAkBBEwBEMeta } from "/codebuild/output/src2471201338/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93LXAqYzYFiON_45NuH_45KlIQsx8Vz8570TXB8_x72cMcxBYMeta } from "/codebuild/output/src2471201338/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancek0jyNV5MpN9DDAWzL1EHavywbFYTvp_45pH_45mHZvtdLQQMeta } from "/codebuild/output/src2471201338/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93Clv1Niewlxl5hivajgk9zLQQtamCWILL5kIoaxes7nQMeta } from "/codebuild/output/src2471201338/src/src/pages/notice/[id].vue?macro=true";
import { default as indexPvPXciFfIzYKGHi2JOx6uWL2aHCnIxjTgZP0tokNy8QMeta } from "/codebuild/output/src2471201338/src/src/pages/coupon/index.vue?macro=true";
import { default as index7p2jKzlWzZZIs_45izjYVT7bV_yL4POsBNNWbS8LAO0IsMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/index.vue?macro=true";
import { default as indexunLH_P1vNLn_45eoW9epFQu8HGFRTatfaEPQ_wB5XLfEUMeta } from "/codebuild/output/src2471201338/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93i3_J7lbK7rujRgA_45NHaDAX3GYMImbcCuOiMIvopNlW4Meta } from "/codebuild/output/src2471201338/src/src/pages/parking/[id].vue?macro=true";
import { default as indexG_45VT5JeeZwcNJzMyH6TRj2Bxg6e2z3vNhZWEtZRNX7QMeta } from "/codebuild/output/src2471201338/src/src/pages/history/index.vue?macro=true";
import { default as indexgq_45C3lSmDYaEOKDK3fIT15Ej_jA2cZjvkac4LgNz3gAMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/index.vue?macro=true";
import { default as indexG3L1uxVCK0XjGbkkwxKBhBh4fmnwPxtikLTd6jfJEDoMeta } from "/codebuild/output/src2471201338/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexHGN8l55KF0PeBZ_451OXKDNL51oj5zmnhHDf2E_PeRjF8Meta } from "/codebuild/output/src2471201338/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviJ8n9i2u6lo7QwcnaNji_45hqGgj6kQ34YIR9_zWMTcRP4Meta } from "/codebuild/output/src2471201338/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editT3xWnttxjsfkHzZ13EamKNwdroL5N5uWpbGG2lGYeKQMeta } from "/codebuild/output/src2471201338/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementJa8ENF6j3Q9gr9Bk3bMSWFUtBvDjrrpamxkXS8IbL3QMeta } from "/codebuild/output/src2471201338/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexD1wK1twC9Y9TuoqqWcPK1nrUoUNEPsAvrPsXGUELfsUMeta } from "/codebuild/output/src2471201338/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dDW2VBQWQWjSOkXBy1AlykYnNU6CPeQB_oHj5iNjP7MYMeta } from "/codebuild/output/src2471201338/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmeO_XbMW2kpCFCc7h6twOvH_tV9mGTRJMjQJqRLkFuboMeta } from "/codebuild/output/src2471201338/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexbaB5Z4p_4566PaglCLcqgFtBOQm8vGaguVc5n21HL_458OYMeta } from "/codebuild/output/src2471201338/src/src/pages/card/create/index.vue?macro=true";
import { default as index3c_45UQc0LwAL17c_6UgV2PxhDK8BFSsKyLKw0AQ7booAMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmjK2NfwqUCthDFYBFFItAF_45wINWxocuUQffoFSa4L9pUMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmsRuRKtqiH7LOsJEiwg_453oaXcHGI01BL_vil78bFZ29cMeta } from "/codebuild/output/src2471201338/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete88VeNRzOToB545BlcabVm9kQvK3eVF4THAFBrhit5tAMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/complete.vue?macro=true";
import { default as registerE2VFiLlTmDoYPNMiouABYKEXZ5uQssKYYICKiOJySsgMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93It7NisArnSJO_cKKbFT5TjRh_EIe_fxuFMqD9qY_45secMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmh3WHwQL_4596WScpvr_nuFRULoFrrzdoJ4RgLH2Hf9oj0Meta } from "/codebuild/output/src2471201338/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_45f1u_gH594alOPB1emQSve1BrO8EdmFNUw_45GnMUI5ikMeta } from "/codebuild/output/src2471201338/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexCLs_45j3WVmreQMcnpjJ3grhy6uNFT65fORBD_45JUhhmE8Meta } from "/codebuild/output/src2471201338/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codes0QYA57v_Cx8B_s_5DuhWMpZlBU_45A11XkJIRjCpspQ8Meta } from "/codebuild/output/src2471201338/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code0oAuivBHgcKMQtbsw0FczLRH1U0mUmfytXHuxw3XHgQMeta } from "/codebuild/output/src2471201338/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completelWURXAwj0OsPNfzfBJYpl_iB0kD_SA7WrVaqj1ZH6y0Meta } from "/codebuild/output/src2471201338/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeraw_c5jojSnajOnKSMivhnLB4assjQIkAQ8Yfw0WZtSQMeta } from "/codebuild/output/src2471201338/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeJO_qzTNkVLc7DPwRLdQzUpG_45OYe0pRZ7yaSnROSQrogMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexH91kY_45sB33a5mcoFJY1DhxcXFgJ3yN3rl_45qkhww5tjsMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmE_RQ7RZPIrtSVdZs7_459v4QOHD_O916_45H1tl208_kLssMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete1CpOPxtCKUnnSjssrs7LUThVDPul9hEFo4cgbFS3YtkMeta } from "/codebuild/output/src2471201338/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index49bfGxFIMlFqbZJPiSwpKvTiYEFv3RkCWSXApjx_MWwMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93q3jGEoZQkaO_4559r40gjiTmqfagnueQaZy2zqet_45dcogMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeihXr4jmlfLorn_45THB_45WnjR6F_95wNkMcpf2LxPgY7uEMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasLt5mAiNJRXUxahyc4BPq0ncQqRf3ErK9eCLrXLnTAQwMeta } from "/codebuild/output/src2471201338/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplexopLVjOhGl8i4_hGARYySJkWm0X64x_E3zGbde7R_45HMMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailA6YK0gexijpWoAbRhneyFEcXudzkjJ_45UiJ6FLFegYhsMeta } from "/codebuild/output/src2471201338/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmTD3msZaqlNYQXPRgMwqVshSfw41CRMyxyTCPl0u_45P_450Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentWtHYI6S13hJcGdluORQrlOiVQ__qeNVRhuI_45irmucb4Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmQ509d1_SeiME__45D18MksSPFcBwztpBSipaV6SGAeaDQMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatehp7gCVEdP7IH_456r2ijasHuFfETOH2Ytd6F8Q4rx1g9IMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeHBTjjNbMoR2GZ8bmQec902_45Ibzy_45ioUCtw9K3uywencMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeo0YUiURraAIkSochTvjU4ZgI6iIKZruRpSJ3911GcuMMeta } from "/codebuild/output/src2471201338/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordkw03oCKfu2Z8kqVb1UmwNh_rqPurmcJQA71i4xwswPQMeta } from "/codebuild/output/src2471201338/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasEF3uJr02LxY2lxw6FWWJdr0z78knzUPWK9jFaiVlD8gMeta } from "/codebuild/output/src2471201338/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerLvDAc7FqS8xXHysv1KxLbN6oX6KdpE5_45LycFSv1PBCgMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeFo4_qNp_i5eUGL8qHjh2QFNkXHXOU8cQS4RXeLJOCDkMeta } from "/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index_EzrPdPJJjEBg7DYdogflXvR2LyvqiGjtaIEZyMTkaEMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index_nxPOfHGE1eGylsScEI73fXSUtixXoa_450NWggVkUtdQMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexf5Msk9yEKjHs6M2cIyIJFwFq_45joniIoOOyiIUuaYrEEMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexfqYSpJZUPqufZVyR_45HxzRbJJSxUQpLgtYnUdQEGk_45q8Meta } from "/codebuild/output/src2471201338/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateSaq72XBIh43DgVNujYKUTCgJmBeU5nQmaE2UYcrRytMMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete9dBogQnYrHioRYHFqYk8oFUcIUyN1FzN9Ccubt1XUKMMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmwyd76cSNsKQJ35JUMbCIEUFqC39HGx_Idzg2GSmkiGMMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexwKlOWCs8MYvqqWVdfiYG1NfwbtZT019zC7StqLYw_459kMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeWvwEszvNHIlbA04ODHQvQ5GfrGE4jfrWxy5J45wlHX8Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatezWvr2riyP27M_45wbntfAYxxrGBnyAl8OReLeeJysSYn0Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexApICATOddJxFikEvY8tJZ_NbPYH4UiRItW4WgIuJw30Meta } from "/codebuild/output/src2471201338/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexBUoL6biLwhJpAujv85KleLKTuSRZ0H9Obdy9j4S_45TMcMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeq3qfjw3AipXcSP_456togS_lwE8phc2DN5XGtwehxrlP4Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexjQaOvtmKDBTuQL_45BaS2CtS3q4RMyLlNLfW3xtaHJ3hQMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codetkSb_451h4mNjVrgW23_45rx1jPAIjFVeOtGiryRzXNRzUcMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index16HNDWscRKvHH5mg_456L8BJEO1RuXROOjgjLOJn5oUnAMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexSEkUdyX87uHii7lCsUMKcR4yiQPgLCKFzGlXs1BhHpwMeta } from "/codebuild/output/src2471201338/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexBMxNc4hx0is8m7i_ThoWVIMBbGyH62e679KGqVUtP80Meta } from "/codebuild/output/src2471201338/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatehoPc7RkLqq_ePgRAj9yHEZBdJSTSMBfhWIRPY8_459mo0Meta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm8S9WzyrHAUJvLih9UIjhvnQKDkueGgVEsA62bE3tytsMeta } from "/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuB8AirgDu1slVU1nP_Lf15aAsNpHyJ9V_45BJYcC3OgjecMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indextb_45RV_45b33YfrNCGeVJzr_ioFH3NGlVggVbeP2bMJsvoMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexPvPXciFfIzYKGHi2JOx6uWL2aHCnIxjTgZP0tokNy8QMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexG_45VT5JeeZwcNJzMyH6TRj2Bxg6e2z3vNhZWEtZRNX7QMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexG3L1uxVCK0XjGbkkwxKBhBh4fmnwPxtikLTd6jfJEDoMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexHGN8l55KF0PeBZ_451OXKDNL51oj5zmnhHDf2E_PeRjF8Meta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexbaB5Z4p_4566PaglCLcqgFtBOQm8vGaguVc5n21HL_458OYMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmjK2NfwqUCthDFYBFFItAF_45wINWxocuUQffoFSa4L9pUMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmsRuRKtqiH7LOsJEiwg_453oaXcHGI01BL_vil78bFZ29cMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete88VeNRzOToB545BlcabVm9kQvK3eVF4THAFBrhit5tAMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerE2VFiLlTmDoYPNMiouABYKEXZ5uQssKYYICKiOJySsgMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmh3WHwQL_4596WScpvr_nuFRULoFrrzdoJ4RgLH2Hf9oj0Meta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codes0QYA57v_Cx8B_s_5DuhWMpZlBU_45A11XkJIRjCpspQ8Meta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code0oAuivBHgcKMQtbsw0FczLRH1U0mUmfytXHuxw3XHgQMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completelWURXAwj0OsPNfzfBJYpl_iB0kD_SA7WrVaqj1ZH6y0Meta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeraw_c5jojSnajOnKSMivhnLB4assjQIkAQ8Yfw0WZtSQMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmE_RQ7RZPIrtSVdZs7_459v4QOHD_O916_45H1tl208_kLssMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete1CpOPxtCKUnnSjssrs7LUThVDPul9hEFo4cgbFS3YtkMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index49bfGxFIMlFqbZJPiSwpKvTiYEFv3RkCWSXApjx_MWwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeihXr4jmlfLorn_45THB_45WnjR6F_95wNkMcpf2LxPgY7uEMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplexopLVjOhGl8i4_hGARYySJkWm0X64x_E3zGbde7R_45HMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailA6YK0gexijpWoAbRhneyFEcXudzkjJ_45UiJ6FLFegYhsMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmTD3msZaqlNYQXPRgMwqVshSfw41CRMyxyTCPl0u_45P_450Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentWtHYI6S13hJcGdluORQrlOiVQ__qeNVRhuI_45irmucb4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmQ509d1_SeiME__45D18MksSPFcBwztpBSipaV6SGAeaDQMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeHBTjjNbMoR2GZ8bmQec902_45Ibzy_45ioUCtw9K3uywencMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeo0YUiURraAIkSochTvjU4ZgI6iIKZruRpSJ3911GcuMMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordkw03oCKfu2Z8kqVb1UmwNh_rqPurmcJQA71i4xwswPQMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerLvDAc7FqS8xXHysv1KxLbN6oX6KdpE5_45LycFSv1PBCgMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeFo4_qNp_i5eUGL8qHjh2QFNkXHXOU8cQS4RXeLJOCDkMeta || {},
    component: () => import("/codebuild/output/src2471201338/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2471201338/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]